"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalRule = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
exports.HorizontalRule = styled_1.default.hr `
	margin: 0;
	width: 100%;
	height: 1px;
	background-color: ${merlin_theme_1.default.colours.neutral.light};
	border: 0;
`;
//# sourceMappingURL=HorizontalRule.js.map